module.exports = __webpack_public_path__ + "static/media/dinein.ca17f2ac.svg";